import {
  LOG_IN,
  LOG_IN_ADMIN,
  CHECK_ADMIN,
  FETCH_USER,
  CREATE_ACCOUNT,
  VERIFY_ACCOUNT,
  VERIFY_EDITED_ACCOUNT,
  UPDATE_EDITED_ACCOUNT,
  UPDATE_PREFERENCES,
  PASSWORD_RESET_STATUS,
  LOG_OUT,
} from "./types";
import { setAlert } from "./alertActions";
import axios from "axios";
import { I18n, setLocale } from "react-redux-i18n";
import {
  fetchTranslationV2,
  loadMissingLanguage,
} from "../actions/languageActions";

export const fetchUser = (prefix, username) => (dispatch) => {
  axios
    .get("/api/private/users", {
      params: { mobile: username, internationalPrefix: prefix },
    })
    .then((res) => {
      dispatch({
        type: FETCH_USER,
        payload: res.data[0],
      });

      axios.defaults.headers.common["language"] = res.data[0].language;
      dispatch(setLocale(res.data[0].language));
    })
    .catch((err) => {
      if (err && err.response && err.response.data && err.response.data.code)
        dispatch(setAlert(I18n.t(err.response.data.message), "danger"));

      if (axios.isCancel(err)) console.log("axios", err);
      else console.log(err);
    });
};

export const fetchUserEmail = (email) => (dispatch) => {
  axios
    .get("/api/private/users/byEmail", {
      params: { email: email },
    })
    .then((res) => {
      dispatch({
        type: FETCH_USER,
        payload: res.data[0],
      });
    })
    .catch((err) => {
      if (err && err.response && err.response.data && err.response.data.code)
        dispatch(setAlert(I18n.t(err.response.data.message), "danger"));

      if (axios.isCancel(err)) console.log("axios", err);
      else console.log(err);
    });
};

export const login =
  (prefix, username, password, isWhiteLabel) => (dispatch) => {
    const packet = {
      internationalPrefix: prefix,
      username: username,
      password: password,
    };

    axios
      .post(isWhiteLabel ? "/api/wl/authenticate" : "/api/authenticate", packet)
      .then((res) => {
        dispatch(loadMissingLanguage(res.data?.language));
        dispatch({
          type: LOG_IN,
          payload: res.data,
        });
        if (res.data.mobile) {
          dispatch(fetchUser(res.data.internationalPrefix, res.data.mobile));
        } else {
          dispatch(fetchUserEmail(res.data.email));
        }
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message
        )
          dispatch(setAlert(I18n.t(err.response.data.message), "danger"));
        if (axios.isCancel(err)) console.log("axios", err);
        else console.log(err);
      });
  };

export const loginBusiness =
  (username, password, isWhiteLabel) => (dispatch) => {
    const packet = {
      username: username,
      password: password,
    };
    axios
      .post(
        isWhiteLabel ? "/api/wl/authenticate" : "/api/company/authenticate",
        packet
      )
      .then((res) => {
        dispatch(loadMissingLanguage(res.data?.language));

        dispatch({
          type: LOG_IN,
          payload: res.data,
        });
        if (res.data.mobile) {
          dispatch(fetchUser(res.data.internationalPrefix, res.data.mobile));
        } else {
          dispatch(fetchUserEmail(res.data.email));
        }
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message
        )
          dispatch(setAlert(I18n.t(err.response.data.message), "danger"));
        if (axios.isCancel(err)) console.log("axios", err);
        else console.log(err);
      });
  };

export const loginAdmin = (username, password, clientEmail) => (dispatch) => {
  const packet = {
    clientEmail: clientEmail,
    password: password,
    username: username,
  };
  axios
    .post("/api/adminUser/authenticate", packet)
    .then((res) => {
      dispatch(loadMissingLanguage(res.data.language));

      dispatch({
        type: LOG_IN_ADMIN,
        payload: res.data,
      });
      if (res.data.mobile) {
        dispatch(fetchUser(res.data.internationalPrefix, res.data.mobile));
      } else {
        dispatch(fetchUserEmail(res.data.email));
      }
    })
    .catch((err) => {
      if (err && err.response && err.response.data && err.response.data.code)
        dispatch(setAlert(I18n.t(err.response.data.message), "danger"));
      if (axios.isCancel(err)) console.log("axios", err);
      else console.log(err);
    });
};

export const checkAdmin = (username, password) => (dispatch) => {
  const packet = {
    password: password,
    username: username,
  };
  axios
    .post("/api/adminUser/authenticate", packet)
    .then((res) => {
      dispatch({
        type: CHECK_ADMIN,
        payload: {
          data: res.data,
        },
      });
    })
    .catch((err) => {
      if (err && err.response && err.response.data && err.response.data.code)
        dispatch(setAlert(I18n.t(err.response.data.message), "danger"));
      if (axios.isCancel(err)) console.log("axios", err);
      else console.log(err);
    });
};

export const createAccount =
  (
    username,
    password,
    email,
    name,
    mobile,
    licenseAgreement,
    country,
    language,
    internationalPrefix,
    imageContent
  ) =>
  (dispatch) => {
    const post = {
      username,
      password,
      email,
      name,
      mobile,
      licenseAgreement,
      country,
      language,
      internationalPrefix,
      imageContent,
    };

    axios
      .post("/api/private/users", post)
      .then((res) => {
        dispatch({
          type: CREATE_ACCOUNT,
          payload: {
            data: {
              internationalPrefix: res.data.internationalPrefix,
              mobile: res.data.mobile,
              username: res.data.username,
            },
          },
        });
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message
        )
          dispatch(setAlert(I18n.t(err.response.data.message), "danger"));
        if (axios.isCancel(err)) console.log("axios", err);
        else console.log(err);
      });
  };

export const verifyCode = (internationalPrefix, mobile, code) => (dispatch) => {
  const patch = {
    internationalPrefix,
    mobile,
    code,
  };

  axios
    .patch("/api/accountActivation", patch)
    .then((res) => {
      if (res.status === 200) {
        dispatch({
          type: VERIFY_ACCOUNT,
          payload: true,
        });
        dispatch(
          setAlert(I18n.t("server_account_successfully_activated"), "primary")
        );
      }
    })
    .catch((err) => {
      if (err && err.response && err.response.data && err.response.data.code)
        dispatch(setAlert(I18n.t(err.response.data.message), "danger"));
      if (axios.isCancel(err)) console.log("axios", err);
      else console.log(err);
    });
};

export const verifyEditedAccountCode = (email, code) => (dispatch) => {
  const patch = {
    email,
    code,
  };

  axios
    .patch("/api/accountActivation/email", patch)
    .then((res) => {
      if (res.status === 200) {
        dispatch({
          type: VERIFY_EDITED_ACCOUNT,
          payload: false,
        });
        dispatch(
          setAlert(I18n.t("server_account_successfully_activated"), "primary")
        );
      }
    })
    .catch((err) => {
      if (err && err.response && err.response.data && err.response.data.code)
        dispatch(setAlert(I18n.t(err.response.data.message), "danger"));
      if (axios.isCancel(err)) console.log("axios", err);
      else console.log(err);
    });
};

export const updateVerifyEditedAccountState = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_EDITED_ACCOUNT,
    payload: data,
  });
};

export const updateAccountData = (prefix, username) => (dispatch) => {
  dispatch(fetchUser(prefix, username));
};

export const updatePasswordResetStatus = (status) => (dispatch) => {
  dispatch({
    type: PASSWORD_RESET_STATUS,
    payload: status,
  });
};

export const updatePreferences = (preferences) => (dispatch) => {
  dispatch({
    type: UPDATE_PREFERENCES,
    payload: preferences,
  });
};

export const logout =
  (invalidLogin = false, wasAdmin = false) =>
  (dispatch) => {
    axios
      .patch("/api/private/logout")
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: LOG_OUT,
            payload: { invalidLogin, wasAdmin },
          });
        }
      })
      .catch((err) => {
        // if invalid user, force logout
        if (invalidLogin) {
          dispatch({
            type: LOG_OUT,
            payload: { invalidLogin, wasAdmin },
          });
        }
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message
        )
          dispatch(setAlert(I18n.t(err.response.data.message), "danger"));
        if (axios.isCancel(err)) console.log("axios", err);
        else console.log(err);
      });
  };
